(() => {
  const forms = [...document.querySelectorAll('product-form[data-bogos-pair-gated]')];
  if (forms.length === 0) return;
  const offerCode = 'LONGEVITY50';
  let selectedPair = null;
  let applyingCode = false;

  const update = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    const productIds = new Set(cart.items.map((item) => String(item.product_id)));
    forms.forEach((form) => {
      form.toggleAttribute(
        'data-bogos-pair-ready',
        productIds.size === 1 && productIds.has(form.dataset.productId)
      );
    });
  };

  const matchesSelection = (cart, pair) => {
    const items = cart.items.filter((item) => item.quantity > 0);
    return items.length === 2
      && items.every((item) => item.quantity === 1)
      && new Set(items.map((item) => String(item.product_id))).size === 2
      && items.some((item) => String(item.product_id) === pair.primaryProductId)
      && items.some((item) => String(item.variant_id) === pair.secondVariantId
        && String(item.product_id) !== pair.primaryProductId);
  };

  const applyCode = async (cart) => {
    if (!selectedPair || applyingCode) return;
    if (Date.now() > selectedPair.expiresAt) {
      selectedPair = null;
      return;
    }
    if (!matchesSelection(cart, selectedPair)) return;

    const existingCodes = (cart.discount_applications || [])
      .filter((application) => application.type === 'discount_code')
      .map((application) => application.code || application.title)
      .filter(Boolean);
    if (existingCodes.some((code) => code.toUpperCase() === offerCode)) {
      selectedPair = null;
      return;
    }

    applyingCode = true;
    try {
      const response = await fetch(`${theme.routes.cart}/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: [...new Set([...existingCodes, offerCode])].join(',') })
      });
      if (!response.ok) return;
      const updatedCart = await response.json();
      selectedPair = null;
      update(updatedCart);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } catch {} finally {
      applyingCode = false;
    }
  };

  const refresh = async () => {
    try {
      const response = await fetch(`${theme.routes.cart}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      update(cart);
      await applyCode(cart);
    } catch {}
  };

  for (const eventName of ['on:cart:add', 'on:line-item:change']) {
    document.addEventListener(eventName, (event) => {
      if (event.detail?.cart) update(event.detail.cart);
      else refresh();
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('#bogos-cheapest-discount-view .bogos-cheapest-product-add-btn[data-variant-id]');
    const form = button?.closest('product-form[data-bogos-pair-gated][data-bogos-pair-ready]');
    if (!form) return;
    selectedPair = {
      primaryProductId: form.dataset.productId,
      secondVariantId: button.dataset.variantId,
      expiresAt: Date.now() + 15000
    };
    setTimeout(refresh, 500);
    setTimeout(refresh, 1500);
    setTimeout(refresh, 3000);
    setTimeout(refresh, 7000);
  }, true);

  if (window.PerformanceObserver) {
    try {
      const observer = new PerformanceObserver((list) => {
        if (list.getEntries().some((entry) => {
          const url = new URL(entry.name);
          return url.origin === location.origin
            && /(?:^|\/)cart\/(?:add|change|update|clear)(?:\.js)?$/.test(url.pathname);
        })) refresh();
      });
      observer.observe({ entryTypes: ['resource'] });
    } catch {}
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });

  refresh();
})();


